module.exports = __webpack_public_path__ + "static/media/logo.f509a810.png";